import { Star, Quote } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";

const items = [
  { name: "Priya Sharma", role: "Parent · Class 5, CBSE", text: "The alternate-week tests changed everything. We finally see exactly where our daughter stands, and her maths confidence has shot up." },
  { name: "Rahul Verma", role: "Parent · Class 7, ICSE", text: "1-on-1 attention you simply don't get in coaching centres. The tutor moves at my son's pace and sticks to his school syllabus." },
  { name: "Anjali Nair", role: "Parent · Class 2 + Abacus", text: "Booked a free demo on a whim. Loved that classes are scheduled around us. The Abacus program is a lovely bonus." },
];

export const Testimonials = () => (
  <section className="py-24 md:py-32 max-w-7xl mx-auto px-5 md:px-8">
    <Reveal>
      <Overline>Loved by parents</Overline>
      <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight max-w-xl">Families across India trust us with what matters most.</h2>
    </Reveal>
    <div className="grid md:grid-cols-3 gap-6 mt-12">
      {items.map((t, i) => (
        <Reveal key={t.name} delay={0.07 * i}>
          <div className="bg-white rounded-3xl border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8 h-full hover:-translate-y-2 transition-transform duration-300">
            <Quote className="text-secondary" size={28} />
            <div className="flex gap-0.5 mt-4">
              {Array.from({ length: 5 }).map((_, k) => <Star key={k} size={16} className="text-accent fill-accent" />)}
            </div>
            <p className="mt-4 text-foreground/80 leading-relaxed">"{t.text}"</p>
            <div className="mt-6 pt-5 border-t border-black/5">
              <div className="font-heading font-bold">{t.name}</div>
              <div className="font-label text-sm text-muted-foreground">{t.role}</div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Testimonials;
